import React from 'react';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-container">
        <div className="loading-logo">
          <div className="logo-circle">
            <img src="/B1Logo.png" alt="B1 Health Corp Logo" className="loading-logo-image" />
          </div>
        </div>
        <div className="loading-text">
          <h2>B1 Health Corp</h2>
          <p>Loading comprehensive healthcare solutions...</p>
        </div>
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
